import { Dialog, DialogContent, LinearProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "../../hooks/useTranslation";

type ProgressPopup = {
    open: boolean;
    label: string;
};

export const ProgressPopup = (props: ProgressPopup) => {
    const [open, setOpen] = useState(props.open);

    useEffect(() => {
        setOpen(props.open);
    }, [props.open]);
    const {t} = useTranslation();

    return (
        <Dialog
            open={open}
            fullWidth={true}
            aria-labelledby="form-dialog-title"
            style={{ zIndex: 90300 }}
        >
            <DialogContent>
                <LinearProgress style={{ marginBottom: "14px" }} />
                <Typography variant="body1">
                   {t(props.label)}
                </Typography>
            </DialogContent>
        </Dialog>
    );
};
